import { Component, HostListener, viewChild } from '@angular/core';
import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { Zone } from '../../bo/zone';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { UtilisateurService } from '../../services/utilisateur.service';


@Component({
  selector: 'app-zone-modale',
  templateUrl: './zone-modale.component.html',
  styleUrls: ['./zone-modale.component.scss'],
  standalone: false
})
export class ZoneModaleComponent {
  readonly modalConfirmCancel = viewChild<ModalDirective>('modalConfirmCancel');
  nomInvalide = false;
  estModif: boolean;
  success = false;
  zone: Zone;
  zoneSauv: Zone;
  erreurApi: boolean;

  constructor(public bsModalRef: BsModalRef, private readonly http: HttpService, private readonly utilService: UtilisateurService, private readonly fonctionsService: FonctionsService) { }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    this.showModalCancel();
  }

  ngOnInit() {
    this.zoneSauv = new Zone();
    if (!this.estModif) {
      this.zone = new Zone();
      this.zone.isActif = true;
      this.zone.zoneId = -1;
    } else {
      Object.assign(this.zoneSauv, this.zone);
    }
  }

  onSubmit() {
    this.erreurApi = false;
    if (this.validationFormulaire()) {
      this.fonctionsService.loading_screen(true);
      this.zone.nom = this.zone.nom.trim();
      this.zone.siteId = this.utilService.currentSite().siteId;

      var requete = this.estModif ? this.http.put<Zone, Zone>('Zones', this.zone) : this.http.post<Zone, Zone>('Zones', this.zone);

      requete.subscribe(resultat => {
        this.fonctionsService.loading_screen(false);
        if (resultat) {
          this.zone = resultat;
          this.success = true;
        }
        else
          this.erreurApi = true;
        if (!this.erreurApi) {
          this.fonctionsService.launch_toast(this.success);
          this.bsModalRef.hide();
        }
      }, () => {
        this.erreurApi = true;
        this.fonctionsService.loading_screen(false);
      });
    }
  }

  validationFormulaire() {
    this.nomInvalide = this.fonctionsService.stringEstVide(this.zone.nom);

    return !this.nomInvalide;
  }

  showModalCancel() {
    if (this.diff()) {
      this.modalConfirmCancel().show();
    } else {
      this.annulModif();
    }
  }

  diff() {
    if (this.estModif) {
      return this.zone.nom !== this.zoneSauv.nom ||
        this.zone.isActif !== this.zoneSauv.isActif;
    } else {
      return this.zone.nom;
    }
  }

  annulModif() {
    if (!this.estModif)
      this.zone.zoneId = -1;
    else
      Object.assign(this.zone, this.zoneSauv);
    this.bsModalRef.hide();
  }
}
